import { Component, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { finalize, Subscription } from 'rxjs';
import { CollectionsService } from '../../services/collections.service';
import { CollectionCardComponent } from '../collection-card/collection-card.component';
import { Collection, CollectionAction } from '../../interfaces/collection.interface';
import { CollectionEventsService } from '../../../../shared/services/collection.service';

@Component({
  selector: 'app-collections',
  standalone: true,
  imports: [CommonModule, CollectionCardComponent],
  templateUrl: './collections.component.html',
  styleUrl: './collections.component.css'
})
export class CollectionsComponent implements OnInit, OnDestroy {
  @Output() backClick = new EventEmitter<void>();

  collections: Collection[] = [];
  isLoading = true;
  error: string | null = null;

  private subscriptions = new Subscription();

  constructor(private collectionsService: CollectionsService,private collectionEvents: CollectionEventsService) {}

  ngOnInit(): void {
    this.loadCollections();
    this.collectionEvents.reload$.subscribe(() => {
    this.reloadCollections();
  });
  }
  
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  // loadCollections(): void {
  //   this.subscriptions.add(
  //     this.collectionsService.getCollections().subscribe({
  //       next: (collections) => {
  //         this.collections = collections;
  //         this.isLoading = false;
  //       },
  //       error: (error) => {
  //         this.error = 'Failed to load collections';
  //         this.isLoading = false;
  //         console.error('Error loading collections:', error);
  //       }
  //     })
  //   );
  // }
  reloadCollections():void{
    this.loadCollections();
  }

loadCollections(): void {
  this.isLoading = true;

  this.subscriptions.add(
    this.collectionsService.getCollections().subscribe({
      next: (response) => {
        // safely unwrap the nested collections
        this.collections = response?.data ?? [];
        this.collections.forEach(collection =>{collection.isExpanded=true})
        this.isLoading = false;
      },
      error: (error) => {
        this.error = 'Failed to load collections';
        this.isLoading = false;
        console.error('Error loading collections:', error);
      }
    })
  );
}

  onBackClick(): void {
    this.backClick.emit();
  }

  onCollectionAction(action: CollectionAction): void {
    if (action.type === 'add_document' && action.data) {
      }
    this.collectionsService.performAction(action);
  }

  trackByCollectionId(index: number, collection: Collection): string {
    return collection.id;
  }
}
